/*@flow*/
import checkStatus from 'lib/checkStatus';
import fetchSmart from 'lib/fetchSmart';

const fetchAndCheck = (...args) => fetchSmart(...args).then(checkStatus);

export default {
  fetch(
    url: string | URL,
    opts?: Object = { method: 'GET' }
  ): Promise<Response> {
    return (fetchAndCheck(url, opts): any);
  },
  fetchJson<T: Object>(
    url: string | URL,
    opts?: Object = { method: 'GET' }
  ): Promise<T> {
    return fetchAndCheck(url, opts).then(
      (res: any) => res.json(),
      e => e.response.json().then(err => Promise.reject(err))
    );
  },
};
